function fetchScript(url, params) {
  var searchParams = new URLSearchParams();
  Object.keys(params || {}).forEach(function(key) {
    var value = params[key];
    if (Array.isArray(value)) {
      value.forEach(function(item) {
        searchParams.append(key + '[]', item);
      });
    } else if (value != null) {
      searchParams.append(key, value);
    }
  });

  fetch(url + '?' + searchParams.toString(), {
    headers: {
      'Accept': 'text/javascript, application/javascript, */*; q=0.01',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  }).then(function(res) {
    return Promise.all([res, res.text()]);
  }).then(function(result) {
    var res = result[0];
    var js = result[1];
    var contentType = (res.headers.get('content-type') || '').toLowerCase();
    var trimmed = js.replace(/^\s+/, '');
    // Don't blindly inject the response as a <script> — when the server
    // returns 4xx/5xx (or any HTML), the browser tries to parse the doctype
    // and throws SyntaxError. Fail loudly in the console instead.
    if (!res.ok || (contentType.indexOf('javascript') === -1 && trimmed.charAt(0) === '<')) {
      throw new Error('Expected JavaScript from ' + res.url + ' but received ' + (contentType || 'unknown content type'));
    }
    var script = document.createElement('script');
    script.textContent = js;
    document.head.appendChild(script);
    document.head.removeChild(script);
  }).catch(function(error) {
    console.error(error);
  });
}

var widgetPriceCompactInitialize = function() {
  var cardsArray = [];
  document.querySelectorAll(".widget-price-compact-placeholder").forEach(function(el) {
    cardsArray.push(el.dataset.card);
  });
  if (cardsArray.length > 0) {
    var chunk = 25;
    for (var i = 0; i < cardsArray.length; i += chunk) {
      var tempArray = cardsArray.slice(i, i + chunk);
      fetchScript("/widgets/price_compact/js", { cards: tempArray });
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  widgetPriceCompactInitialize();
});
